import { Skeleton } from "@/app/components/shadcn/skeleton";

const ReviewSellerInfoSkeleton = () => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
      <div className="flex items-center gap-3">
        <Skeleton className="w-10 h-10 rounded-lg" />
        <div className="flex-1 space-y-2">
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-5 w-8 rounded-md" />
            <Skeleton className="w-4 h-4 rounded-full" />
          </div>
        </div>
      </div>
      <hr className="my-4 border-gray-300" />
      <Skeleton className="h-4 w-40" />
    </div>
  );
};

export default ReviewSellerInfoSkeleton;